import { render, staticRenderFns } from "./inicio.vue?vue&type=template&id=f66fa6ca&scoped=true&"
import script from "./inicio.vue?vue&type=script&lang=js&"
export * from "./inicio.vue?vue&type=script&lang=js&"
import style0 from "./inicio.vue?vue&type=style&index=0&id=f66fa6ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f66fa6ca",
  null
  
)

export default component.exports